<ng-container *ngIf="view$ | async as view">
  <section class="progress-sheet" *ngIf="view.items.length">
    <div
      class="progress-sheet__top"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)"
      (click)="toggleExpanded()"
    >
      <span class="progress-sheet__handle" aria-hidden="true"></span>

      <button
        type="button"
        class="progress-sheet__heading"
        [attr.aria-expanded]="expanded"
      >
        <ng-container [ngSwitch]="view.phase">
          <app-rotating-title
            *ngSwitchCase="'loading'"
            class="qp-title"
          ></app-rotating-title>

          <span *ngSwitchCase="'slow'" class="qp-title qp-title--icon">
            <img
              *ngIf="showMascot"
              class="qp-mascot"
              src="assets/image/pawsper.png"
              alt=""
            />
            {{
              (view.ready.length
                ? "comparison.progress.slowSomeReadyTitle"
                : "comparison.progress.slowNoneReadyTitle"
              ) | translate
            }}
          </span>

          <span
            *ngSwitchCase="'finished'"
            class="qp-title qp-title--ready qp-title--icon"
          >
            <app-progress-status-icon
              class="qp-ready-icon"
              status="ready"
              [pulse]="false"
            ></app-progress-status-icon>
            {{ "comparison.progress.readyTitle" | translate }}
          </span>
        </ng-container>
      </button>

      <div class="progress-sheet__desc" [@expand]="expanded">
        <p class="qp-desc" [ngSwitch]="view.phase">
          <ng-container *ngSwitchCase="'loading'">
            {{ "comparison.progress.desc" | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="'slow'">
            <ng-container *ngIf="view.ready.length; else noneReady">
              {{ "comparison.progress.slowSomeReadyDesc" | translate }}
            </ng-container>
            <ng-template #noneReady>
              {{
                (view.waiting.length === 1
                  ? "comparison.progress.slowNoneReadyDescOne"
                  : "comparison.progress.slowNoneReadyDesc"
                ) | translate : { n: view.waiting.length }
              }}
            </ng-template>
            {{ "comparison.progress.slowRevisit" | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="'finished'">
            {{ "comparison.progress.readyDesc" | translate }}
          </ng-container>
        </p>
      </div>

      <div
        *ngIf="view.phase === 'loading'"
        class="qp-progress-bar"
        role="progressbar"
        aria-busy="true"
      >
        <span></span>
      </div>
    </div>

    <div class="progress-sheet__chips">
      <ng-container
        *ngTemplateOutlet="
          chip;
          context: { status: 'ready', group: view.ready }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          chip;
          context: { status: 'waiting', group: view.waiting }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          chip;
          context: { status: 'unavailable', group: view.unavailable }
        "
      ></ng-container>
    </div>
  </section>
</ng-container>

<ng-template #chip let-status="status" let-group="group">
  <div class="summary-chip-wrapper" *ngIf="group.length">
    <ul
      *ngIf="openTooltip === status"
      class="summary-tooltip summary-tooltip--{{ status }}"
      [style.--tooltip-shift.px]="tooltipShift"
      role="tooltip"
    >
      <li *ngFor="let item of group">{{ item.name }}</li>
    </ul>
    <button
      type="button"
      class="summary-chip summary-chip--{{ status }}"
      [class.is-open]="openTooltip === status"
      [attr.aria-expanded]="openTooltip === status"
      (click)="toggleTooltip(status)"
    >
      <app-progress-status-icon [status]="status"></app-progress-status-icon>
      <span>+{{ group.length }}</span>
      <span *ngIf="status === 'ready'">{{
        "comparison.progress.chipAvailable" | translate
      }}</span>
      <span *ngIf="status === 'waiting'">{{
        "comparison.progress.chipWaiting" | translate
      }}</span>
      <svg class="summary-chip__info" viewBox="0 0 16 16" aria-hidden="true">
        <circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" />
        <path
          d="M8 7.2v3.8M8 5v.1"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>
</ng-template>
